export default "__VITE_ASSET__043a6bb9__"